import { X } from 'lucide-react';
import { Dialog as Primitive } from 'radix-ui';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/** Dialog de shadcn/ui (sustituye SweetAlert y los modales Bootstrap del legacy). */
export const Dialog = Primitive.Root;
export const DialogTrigger = Primitive.Trigger;
export const DialogClose = Primitive.Close;

export function DialogContent({
  className,
  children,
  ...props
}: ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Portal>
      <Primitive.Overlay className="overlay-cs fixed inset-0 z-50 data-[state=open]:animate-[fadeIn_200ms_ease-out]" />
      <Primitive.Content
        className={cn(
          // Alto máximo de la ventana: el contenido se desplaza por dentro y la X queda fija.
          'vidrio-fuerte fixed top-1/2 left-1/2 z-50 flex max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-[25px] text-texto',
          'data-[state=open]:animate-[zoomIn_220ms_cubic-bezier(0.16,1,0.3,1)]',
          className,
        )}
        {...props}
      >
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-6">{children}</div>
        <Primitive.Close
          className="absolute top-4 right-4 rounded-full p-1.5 text-texto-2 hover:bg-[var(--vidrio-fuerte)] hover:text-texto"
          aria-label="Cerrar"
        >
          <X size={18} />
        </Primitive.Close>
      </Primitive.Content>
    </Primitive.Portal>
  );
}

export function DialogTitle({ className, ...props }: ComponentProps<typeof Primitive.Title>) {
  return (
    <Primitive.Title
      className={cn('pr-8 text-xl font-extrabold text-azul-texto', className)}
      {...props}
    />
  );
}

export function DialogDescription({
  className,
  ...props
}: ComponentProps<typeof Primitive.Description>) {
  return (
    <Primitive.Description className={cn('mt-2 text-sm text-texto-2', className)} {...props} />
  );
}
